import { noop } from 'lodash-es';
import { useCallback, useRef, useState } from 'react';

interface Options {
    threshold?: number;
}

const DEFAULT_THRESHOLD = 24;

export function useIsScrolled(options?: Options) {
    const threshold = options?.threshold ?? DEFAULT_THRESHOLD;
    const cleanupRef = useRef(noop);
    const [isScrolled, setIsScrolled] = useState(false);

    const ref = useCallback(
        (node: HTMLElement | null) => {
            cleanupRef.current();

            if (node instanceof HTMLElement) {
                const handler = () => setIsScrolled(node.scrollTop >= threshold);
                cleanupRef.current = () => {
                    setIsScrolled(false);
                    node?.removeEventListener?.('scroll', handler);
                    cleanupRef.current = noop;
                };
                node.addEventListener('scroll', handler);
                handler();
            }
        },
        [threshold]
    );

    return [isScrolled, ref] as const;
}
